'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _userAvatar = require('@bibliocommons/user-avatar');

var _userAvatar2 = _interopRequireDefault(_userAvatar);

var _userStaffStamp = require('@bibliocommons/user-staff-stamp');

var _userStaffStamp2 = _interopRequireDefault(_userStaffStamp);

require('../styles/UserHeader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserHeader = function (_BcReactComponent) {
  _inherits(UserHeader, _BcReactComponent);

  function UserHeader() {
    _classCallCheck(this, UserHeader);

    return _possibleConstructorReturn(this, (UserHeader.__proto__ || Object.getPrototypeOf(UserHeader)).apply(this, arguments));
  }

  _createClass(UserHeader, [{
    key: 'renderUserStaffStamp',
    value: function renderUserStaffStamp() {
      var userIdentity = this.props.userIdentity;


      if (userIdentity.get('staff')) {
        return _react2.default.createElement(_userStaffStamp2.default, { inverse: true });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          renderActions = _props.renderActions,
          userIdentity = _props.userIdentity,
          renderNav = _props.renderNav;

      var classNames = (0, _classnames2.default)('cp-user-header', { 'home-patron': userIdentity.get('homePatron') });

      return _react2.default.createElement(
        'div',
        { className: classNames },
        _react2.default.createElement(
          'div',
          { className: 'user-header-top' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-8' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-md-8' },
                  _react2.default.createElement(
                    'div',
                    { className: 'pull-left user-header-avatar' },
                    _react2.default.createElement(_userAvatar2.default, { userIdentity: userIdentity, size: 'lg' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'pull-left user-header-info' },
                    _react2.default.createElement(
                      'div',
                      { className: 'user-header-username' },
                      userIdentity.get('name')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'user-header-library' },
                      this.renderUserStaffStamp(),
                      userIdentity.get('homeLibraryFullName')
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-md-4' },
                  _react2.default.createElement('div', { className: 'user-header-about' })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-4' },
              _react2.default.createElement(
                'div',
                { className: 'user-header-actions' },
                renderActions()
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'user-header-bottom' },
          renderNav()
        )
      );
    }
  }]);

  return UserHeader;
}(_baseBcReactComponent2.default);

UserHeader.propTypes = {
  renderActions: _react.PropTypes.func,
  renderNav: _react.PropTypes.func,
  profile: _reactImmutableProptypes2.default.map,
  userIdentity: _bcPropTypes.userIdentityShape.isRequired
};

UserHeader.defaultProps = {
  renderActions: function renderActions() {
    return null;
  },
  renderNav: function renderNav() {
    return null;
  }
};

exports.default = UserHeader;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-header/lib/components/user-header/components/UserHeader.component.js
// module id = 1555
// module chunks = 1